import { ItemLoader, ListLoader } from "@/loaders";

export default {
  categoriesList: new ListLoader("/interview/categories/", {
    setter: "interview/setInterviewCategories",
  }),
  interviewSettings: new ItemLoader("/interview/settings/"),
};
